export function reshape(_ref) {
  var {
    source,
    shape
  } = _ref;
  var result = {};
  var _loop = function _loop(key) {
    if (!Object.prototype.hasOwnProperty.call(shape, key)) {
      return "continue";
    }
    var fn = shape[key];
    result[key] = source.map(state => {
      var result = fn(state);
      return result === undefined ? null : result;
    }, {
      skipVoid: false
    });
  };
  for (var key in shape) {
    var _ret = _loop(key);
    if (_ret === "continue") continue;
  }
  return result;
}